<script setup lang="ts">
import { ReactiveFile } from "~/classes/file/ReactiveFile"

const props = defineProps({
  sharedFolderId: null
})
const { state: sharedFolderState } = useSharedFolders()

const home = new ReactiveFile({
  file: computed({
    get: () => sharedFolderState.value.all[props.sharedFolderId]!.home,
    set: value => sharedFolderState.value.all[props.sharedFolderId]!.home = value,
  }),
  location: "sidebar",
})
</script>

<template>
  <sidebar-entry-file :file="home" class="entry-shared-folder" />
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.entry-shared-folder
  @apply
</style>
